import { Card, Icon, Row } from 'common/components'
import { formatLongMonthAndDateOnly, formatYear } from 'common/dateFormatters'

import './BenefitSummary.less'

type BenefitDetailsSummaryProps = {
  planPeriodStartDate: string
  planPeriodEndDate: string
  primaryBenefitContactName: string
  primaryBenefitContactEmail: string
  familyStatus: string
  classDetails: string
  expenseType: string
  monthlyAllowance: number
}

const BenefitDetailsSummary = ({
  planPeriodStartDate,
  planPeriodEndDate,
  primaryBenefitContactName,
  primaryBenefitContactEmail,
  familyStatus,
  classDetails,
  expenseType,
  monthlyAllowance,
}: BenefitDetailsSummaryProps) => {
  return (
    <Card className={'mb-16'}>
      <div className="font-12 weight-600 color-gray-7 mb-16">YOUR BENEFIT SUMMARY</div>
      <Row justify="space-between" className="color-gray-7 mb-8">
        <div className="flex">
          <Icon type="far fa-calendar-star" className="benefit-summary-icon color-gray-6 mr-4" /> Benefit Period:
        </div>
        <div>
          {formatLongMonthAndDateOnly(planPeriodStartDate)} - {formatLongMonthAndDateOnly(planPeriodEndDate)},{' '}
          {formatYear(planPeriodEndDate)}
        </div>
      </Row>
      <Row justify="space-between" className="mb-8">
        <div className="flex color-gray-8">
          <Icon type="far fa-users-class" className="benefit-summary-icon color-gray-6 mr-4" /> ICHRA Class Assignment
        </div>
        <div className="weight-600">{classDetails}</div>
      </Row>
      <Row justify="space-between" className="mb-8">
        <div className="flex color-gray-8">
          <Icon type="far fa-user-friends" className="benefit-summary-icon color-gray-6 mr-4" /> Family Status
        </div>
        <div className="weight-600">{familyStatus}</div>
      </Row>
      <Row justify="space-between" className="mb-8">
        <div className="flex color-gray-8">
          <Icon type="far fa-briefcase-medical" className="benefit-summary-icon color-gray-6 mr-4" /> Expense type
        </div>
        <div className="weight-600">{expenseType}</div>
      </Row>
      <Row justify="space-between" className="mb-8">
        <div className="flex color-gray-8">
          <Icon type="far fa-money-bill" className="benefit-summary-icon color-gray-6 mr-4" /> Monthly allowance
        </div>
        <div className="weight-600">${monthlyAllowance}</div>
      </Row>
      <Row justify="space-between" className="mb-8">
        <div className="flex color-gray-8">
          <Icon type="far fa-envelope" className="benefit-summary-icon color-gray-6 mr-4" /> Primary Benefit Contact
        </div>
        <a href={`mailto:${primaryBenefitContactEmail}`} target="_blank" rel="noreferrer">
          {primaryBenefitContactName}
        </a>
      </Row>
    </Card>
  )
}

export default BenefitDetailsSummary
